module.exports = __webpack_public_path__ + "assets/img/banner.4f8a29da.png";